/* Скільки товарів уже показано і скільки всього.

   Нескінченне гортання саме по собі не каже, де ти в каталозі: людина
   крутить і не розуміє, це ще десять товарів попереду чи сто. Цей блок
   рахує картки в сітці й показує прогрес.

   Логіку довантаження не чіпаємо — вона в pagination.js теми. Тут лише
   спостерігаємо за сіткою і оновлюємо підпис. */
(function () {
	class PaginationProgress extends HTMLElement {
		connectedCallback() {
			this.total = parseInt(this.dataset.total, 10) || 0;
			this.fill = this.querySelector('.pagination-progress__fill');
			this.label = this.querySelector('.pagination-progress__label');
			this.grid = document.querySelector('[data-id=' + this.dataset.section + ']');
			if (!this.grid || !this.total || !this.fill || !this.label) return;

			this.update();
			this.observer = new MutationObserver(() => this.update());
			this.observer.observe(this.grid, { childList: true });
		}

		disconnectedCallback() {
			if (this.observer) this.observer.disconnect();
		}

		update() {
			const shown = Math.min(this.grid.querySelectorAll('.column').length, this.total);
			const done = shown >= this.total;

			this.fill.style.width = Math.round((shown / this.total) * 100) + '%';
			this.label.textContent = done
				? 'Показано всі ' + this.total
				: 'Показано ' + shown + ' із ' + this.total;
			this.toggleAttribute('data-complete', done);
		}
	}

	if (!customElements.get('pagination-progress')) {
		customElements.define('pagination-progress', PaginationProgress);
	}
})();
